"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lonlat_1 = require("@conveyal/lonlat");
var abstract_geocoder_1 = __importDefault(require("./abstract-geocoder"));
/**
 * An implementation that doesn't use an API for geocoding. Merely allows
 * clicking on the map and finding GPS coordinates by typing them in.
 *
 * @extends Geocoder
 */
var NoApiGeocoder = /** @class */ (function (_super) {
    __extends(NoApiGeocoder, _super);
    function NoApiGeocoder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Use coordinate string parser.
     */
    NoApiGeocoder.prototype.autocomplete = function (query) {
        return this.parseCoordinateString(query.text);
    };
    /**
     * Always return the lat/lon.
     */
    NoApiGeocoder.prototype.reverse = function (query) {
        var _a;
        var _b = query.point, lat = _b.lat, lon = _b.lon;
        lat = this.roundGPSDecimal(lat);
        lon = this.roundGPSDecimal(lon);
        var feature = {
            geometry: { coordinates: [lat, lon], type: "Point" },
            properties: { name: "".concat(lat, ", ").concat(lon) },
            type: "Feature"
        };
        if ((_a = this.geocoderConfig) === null || _a === void 0 ? void 0 : _a.reverseUseFeatureCollection) {
            return Promise.resolve({
                type: "FeatureCollection",
                features: [feature],
                rawGeocodedFeature: feature
            });
        }
        return Promise.resolve({
            lat: lat,
            lon: lon,
            name: feature.properties.name,
            rawGeocodedFeature: feature
        });
    };
    /**
     * Use coordinate string parser.
     */
    NoApiGeocoder.prototype.search = function (query) {
        return this.parseCoordinateString(query.text);
    };
    /**
     * Attempt to parse the input as a GPS coordinate. If parseable, return a
     * feature.
     */
    NoApiGeocoder.prototype.parseCoordinateString = function (string) {
        var feature;
        try {
            feature = {
                geometry: {
                    coordinates: (0, lonlat_1.toCoordinates)((0, lonlat_1.fromLatFirstString)(string)),
                    type: "Point"
                },
                properties: {
                    label: string
                }
            };
        }
        catch (e) {
            return Promise.resolve({ features: [], type: "FeatureCollection" });
        }
        return Promise.resolve({ features: [feature], type: "FeatureCollection" });
    };
    NoApiGeocoder.prototype.roundGPSDecimal = function (number) {
        var roundFactor = 100000;
        return Math.round(number * roundFactor) / roundFactor;
    };
    return NoApiGeocoder;
}(abstract_geocoder_1.default));
exports.default = NoApiGeocoder;
//# sourceMappingURL=noapi.js.map